module.exports = __webpack_public_path__ + "img/main-not-using.b9dcfa96.jpg";